<!-- /src/views/Bookmarks.vue -->
<template>
  <LayoutFullWidth class="landing--page">
    <template v-slot:header>
      <h1 id="page-header" class="page-header">Bookmarks</h1>
          <div class="card-grid-header__actions button__group">
            <button
            class="filter--trigger button button--gray button--sm"
            @click="toggleFilters()"
            ><span v-if="activeQueries.length > 0">Modify Filtered Results</span>
            <span v-else>Filter Results</span></button>
            <button 
              @click="switchListType('cards')" 
              class="filter--trigger button button--gray button--sm"
              :class="{ 'is-active': cardListStyleOptions['cards'] }"
            ><i class="fas fa-th"></i></button>
            <button 
              @click="switchListType('list')"
              class="filter--trigger button button--gray button--sm"
              :class="{ 'is-active': cardListStyleOptions['list'] }"
            ><i class="fas fa-list-ul"></i></button>
            <Sort />
          </div>
    </template>
    <template v-slot:content>
      <div class="main-content">
        <div class="filter-panel"
          v-show="showFilters"
        >
          <Filters postType="bookmarks" />
          <button
            class="button button--gray button--medium button--accent"
            @click="toggleFilters()"
          >Close Filter Panel</button>
        </div>
        <header class="card-grid-header">
          <ActiveQueries />
        </header>
        <Loader
          v-if="isLoading"
          class="relationship__body-content"
          color="gray"
        />
        <NoResults v-else-if="pageCards.length == 0">
          <h2>Whoops, no bookmarks for for these search parameters!</h2>
        </NoResults>
        <div
          v-else-if="pageCards.length > 0"
          class="card--list"
        >
          <template v-if="cardListStyleOptions['list'] == true">
            <Listing :listing="pageCards" :removeElements="removeListItemElements" />
          </template>
          <template v-else-if="cardListStyleOptions['cards'] == true">
            <CardGrid :cards="pageCards" />
          </template>

        </div>
        <Pagination v-if="totalPages > 1" :page="page" :total="totalPages" />
      </div>
    </template>
  </LayoutFullWidth>
</template>




<script>

import LayoutFullWidth from '@/components/layouts/FullWidth'
import CardGrid from '@/components/common/Card/CardGrid'
import Sort from '@/components/common/Sort'
import Filters from '@/components/common/Sidebar/Filters'
import ActiveQueries from '@/components/common/Search/ActiveQueries'
import Pagination from '@/components/common/Pagination'
import searchMixin from '@/mixins/searchMixin'
import Loader from '@/components/common/Loaders/Loader'
import NoResults from '@/components/common/Loaders/NoResults'

import Listing from '@/components/common/List/Listing'

export default {
  name: 'dashboard',
  data() {
    return {
      bookmarkArray: [],
      noCards: false,
      sessionType: 'searchResults',
      cardListStyleOptions: {
        cards: false,
        list: true,
      },
      removeListItemElements: [],
      showFilters: false,
    }
  },
  computed: {
    page() {
      const { page } = Object.create(this.$route.query)
      return typeof page != 'undefined' ? page : 1
    },
    
    isLoading() {
      return !this.$store.getters['posts/postResultsLoaded']('bookmarks')
    },

    bookmarkCards() {
      let cards = this.$store.getters['posts/getBookmarks']
      // console.log(cards)
      // cards = cards.filter(el => {
      //   if (el.id) return el.id
      // })

      // cards = this.searchViaInput(cards)
      // cards = this.filterCards(cards)
      return cards
    },

    // defines the cards displayed on page
    pageCards() {
      return this.bookmarkCards
    },

    itemsPerPage() {
      return this.$store.getters['posts/getItemsPerPage'](this.sessionType)
    },

    totalPages() {
      return this.$store.getters['posts/getTotalPages'](this.sessionType)
    },
  },

  methods: {
    checkCards() {
      setTimeout(() => {
        if (this.bookmarkCards.length == 0) this.noCards = true
      }, 5000)
    },

    switchListType(val) {
      const { cardListStyleOptions } = this
      Object.keys(cardListStyleOptions).forEach(key => {
        cardListStyleOptions[key] = (key == val) ? true : false
      })
    },
  },

  components: {
    LayoutFullWidth,
    Sort,
    ActiveQueries,
    Listing,
    CardGrid,
    Pagination,
    Filters,
    Loader,
    NoResults,
  },

  mixins: [searchMixin],

  mounted() {
    this.$store.dispatch('updatePageTitle', 'Bookmarks')
  },

  // beforeMount() {
  //   this.bookmarkArray = this.$store.getters['user/getBookmarks'].map(
  //     item => item.id,
  //   )
  //   console.log(this.bookmarkArray)
  // },
}
</script>

<style scoped>

.card-grid-header {
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto;
  margin-bottom: 1rem;

  h2 {
    margin-bottom: 0;
  }


  &__actions {
    font-size: 0.7em;
    justify-self: start;
    grid-template-columns: 1fr;
    display: grid;
    @media(--tablet) {
      display: flex;
      /* grid */
    }
  }
}

.filter-panel {
  display: grid;
  margin-bottom: 1rem;
  padding: 1rem;
  gap: 1rem;
  background-color: rgba(var(--gray-RGB), .3);
  border-radius: 4px;

  &> button {
    justify-self: end;
    font-size: .6rem;
    padding: .35rem .5rem;
  }
}

.form__control {
  margin: 0;
}

</style>
